module.exports = __webpack_public_path__ + "static/media/tiny2.6237206c.png";